import { Box, SimpleGrid } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import * as React from 'react';

import { Item } from './Item';

const propTypes = {
  children: (props) => {
    let error;
    React.Children.forEach(props.children, (child) => {
      if (child.type !== Item) {
        error = new Error(
          '`SelectContentGrid` only accepts children of type `SelectContentGrid.Item`.',
        );
      }
    });
    return error;
  },
  'aria-label': PropTypes.string,
  disabledItems: PropTypes.arrayOf(PropTypes.string),
  isDisabled: PropTypes.bool,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  max: PropTypes.number,
};
const defaultProps = {
  'aria-label': 'eligible items',
  disabledItems: [],
  isDisabled: false,
  max: Infinity,
  selectedItems: [],
};

/* This is the Modal from new MP
 *
 * TODO: It is necessary to refactor this part and
 * change to typescript all Select for the all Social Media
 * and the components related with this part.
 */
export const SelectContentGrid = ({
  'aria-label': ariaLabelProp,
  children,
  disabledItems,
  isDisabled,
  max,
  selectedItems,
  ...props
}) => {
  const ariaLabel = isDisabled ? `${ariaLabelProp} (disabled)` : ariaLabelProp;
  const disabledStyles = isDisabled
    ? { opacity: '0.5', pointerEvents: 'none' }
    : {};
  const enhancedChildren = React.Children.map(children, (child) =>
    React.isValidElement(child) && child.type === Item
      ? React.cloneElement(child, {
          // Do not show selected item buttons if grid is disabled
          isSelected: !isDisabled && selectedItems.includes(child.props.id),
          isDisabled: isDisabled || disabledItems.includes(child.props.id),
          hasReachedMax: selectedItems.length >= max,
          max,
        })
      : child,
  );

  return (
    <Box cursor={isDisabled ? 'not-allowed' : 'inherit'}>
      <SimpleGrid
        aria-label={ariaLabel}
        as="ul"
        columns={{ base: 3, sm: 5 }}
        spacing={2}
        sx={disabledStyles}
        {...props}
      >
        {enhancedChildren}
      </SimpleGrid>
    </Box>
  );
};

SelectContentGrid.propTypes = propTypes;
SelectContentGrid.defaultProps = defaultProps;

SelectContentGrid.Item = Item;
